import { Element, Icon } from '@/components/core';
import { isProductOfType } from '@/services/api/parsers/utils';
import { ProductType } from '@/@types';
import React from 'react';
import { msg, Trans } from '@lingui/macro';
import GoogleApiProvider from '@/components/context/google-api';
import PeoopleMap from '@/components/core/components/organism/map';
import { useLingui } from '@lingui/react';
import * as styles from './restaurants.styles';

const dayTranslations = {
  monday: msg`monday`,
  tuesday: msg`tuesday`,
  wednesday: msg`wednesday`,
  thursday: msg`thursday`,
  friday: msg`friday`,
  saturday: msg`saturday`,
  sunday: msg`sunday`,
};

const RestaurantDetails: React.FC<{ product: ProductType }> = ({ product }) => {
  const { i18n } = useLingui();
  if (!isProductOfType(product, ['restaurants'])) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div>
        {product.extra.phone && (
          <div className={styles.item}>
            <Icon className={styles.icon} name="call" />
            <a href={`tel:${product.extra.phone}`} className={styles.details}>
              {product.extra.phone}
            </a>
          </div>
        )}
        {product.extra.location.fullAddress && (
          <div className={styles.item}>
            <span className={styles.icon}>
              <Icon name="location1" />
            </span>
            <Element
              as="a"
              target="_blank"
              href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(product.extra.location.fullAddress)}`}
              lines={1}
              className={styles.details}
            >
              {product.extra.location.fullAddress || 'TEST'}
            </Element>
          </div>
        )}
        {product.url && (
          <div className={styles.item}>
            <Icon name="link" className={styles.icon} />
            <a href={product.url} className={styles.details} target="_blank">
              <Trans>Visit website</Trans>
            </a>
          </div>
        )}
      </div>
      {product.extra.location.geo && (
        <div className={styles.map}>
          <GoogleApiProvider>
            <PeoopleMap disableDetails markers={[product]} center={product.extra.location.geo} />
          </GoogleApiProvider>
        </div>
      )}
      {product.extra.workingHours.length > 0 && (
        <div className="flex flex-col gap-4">
          <h2 className={styles.title}>
            <Trans>Working hours</Trans>
          </h2>
          <div className={styles.workingHours}>
            {product.extra.workingHours.map((workingHour) => {
              return (
                <React.Fragment key={workingHour.weekDay}>
                  <div className={styles.workingHoursDay}>{i18n._(dayTranslations[workingHour.weekDay])}</div>
                  <div className={styles.workingHoursTime}>
                    {workingHour.times.length === 0 && <Trans>Closed</Trans>}
                    {workingHour.times.map(({ from, to }) => {
                      return (
                        <div key={`${from}`}>
                          {from} - {to}
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default RestaurantDetails;
